module.exports = __webpack_public_path__ + "static/media/t2.e7f31dd2.jpg";